
import apiInstance from '../../services/apiService';
const getUserDetails = async () =>{
    try { 
        const response = await apiInstance.get(`cvacoreservices01/api/v2/users/contacts`);
        return { status: response.status, data: response.data };
      } catch (error) {
        console.error('API call failed:', error);
        throw error;
      }
}

const saveUserDetails = async (data) =>{
    try { 
        const response = await apiInstance.put(`cvacoreservices01/api/v2/users/contacts`,data);
        return response.data;
      } catch (error) {
        console.error('API call failed:', error);
        throw error;
      }
}
export { getUserDetails,saveUserDetails };